import { render } from "./SocialNetworks.vue?vue&type=template&id=51ee7981&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=ts"
export * from "./SocialNetworks.vue?vue&type=script&lang=ts"

import "./SocialNetworks.vue?vue&type=style&index=0&id=51ee7981&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51ee7981"

export default script